import type { RootState } from '../index';

export const documentHistorySelector = (state: RootState) => state.audit.documentHistory;

export const versionComparisonSelector = (state: RootState) => state.audit.versionComparison;
